module.exports = "/assets/141aff45da0df4acef79816f9afc2848.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/IT.png
// module id = 2611
// module chunks = 0